// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OYC8O","index":"styles_index__3GY0g"};